<script setup>
import DigiQSection from "@/components/traning&education/DigiQSection.vue";
import QTInduSection from "@/components/traning&education/QTInduSection.vue";
</script>

<template>
  <div class="text-justify">
    <h1 class="heading1">
      Ongoing EU projects
      <hr class="gradientLine" />
    </h1>
    <div class="grid k1:grid-cols-2 grid-cols-1 gap-8">
      <div>
        <p>
          The Quantum Flagship is driving Europe’s second quantum revolution. In
          order for this to succeed, there must be both a trained workforce
          capable of powering the emerging quantum industry, and a quantum-aware
          society which is accepting and open to the substantial impacts it may
          have on our daily lives. For both of these goals, education is a
          crucial lynchpin. Education is firmly a community initiative, first
          coordinated by the
          <a href="https://qtedu.eu/" class="gradientText hoverUnderline">
            QTEdu Coordination and Support</a
          >
          action which has laid in place infrastructures such as:
        </p>
        <ol class="list-disc p-6 space-y-2">
          <li>
            The
            <RouterLink
              to="/education&training/competence-framework"
              class="gradientText hoverUnderline"
            >
              European Competence Framework for Quantum Technologies</RouterLink
            >
            , a map of skills and competences in QT which will be used to
            provide transparency for learning outcomes and industry needs.
          </li>
          <li>
            The
            <a
              href="https://qtedu.eu/qtedu-european-community"
              class="gradientText hoverUnderline"
            >
              QTEdu working groups & community pilots</a
            >
            - 5 working groups and 11 experimental pan-european projects in
            education and training, each with their own focus areas and
            outcomes, pushing the boundaries of how quantum technologies are
            taught.
          </li>
        </ol>
        <p>
          Growing out of the community actions have emerged two large European
          Projects in education & training funded by the Digital Europe
          Programme
          <a
            href="https://digital-strategy.ec.europa.eu/en/activities/digital-programme"
            class="gradientText hoverUnderline"
          >
            Digital Europe Programme</a
          >:
        </p>
      </div>
      <img
        src="/complex-digital.jpeg"
        alt="Ongoing EU Projects"
        class="object-cover rounded-xl w-full h-full"
      />
    </div>

    <div
      class="grid gap-8 k1:grid-cols-2 grid-cols-1 my-10 k1:p-10 p-6 bg-slate-100"
    >
      <DigiQSection />
      <QTInduSection />
    </div>
  </div>
</template>

<style scoped></style>
